import Avatar from "react-avatar";
import { UserModel } from "src/app/types/UserModel";
import { includes } from "lodash";

const UserCell = ({ user }: UserModel | string | null) => {
    if (!user) return <></>;
    const name = typeof user === "string" ? user : `${user.firstName} ${user.lastName}`;
    return (
        <div>
            <Avatar
                round
                className={includes(user.role, "LEAD") ? "avatar-is-Leader" : ""}
                size="24px"
                fgColor={
                    includes(user.role, "LEAD")
                        ? "var(--kt-primary-inverse)"
                        : "var(--kt-secondary-inverse)"
                }
                color={includes(user.role, "LEAD") ? "var(--kt-primary)" : "var(--kt-secondary)"}
                textSizeRatio={2}
                name={name}
            />
        </div>
    );
};

export default UserCell;
